module.exports = __webpack_public_path__ + "img/AC_S4_Final_Echipe_Top5.bc2bbd30.png";